import { Link } from "react-router";
import { MailQuestion } from "lucide-react";
import { paths } from "@shared-core/routing/routes";
import { Card } from "../../../app/components/primitives/card";
import { Button } from "../../../app/components/primitives/button";
import { PortalSignInShell } from "./PortalSignInShell";
import { PortalReviewBar } from "./PortalReviewBar";
import { PortalSignInOutcomeGate } from "./PortalSignInOutcomeGate";

// No access: the person signed in, but CIS has no live link between them and a
// customer. Deliberately opaque. It never says whether we hold a similar
// address, whether a customer exists by that name, or anything else a
// stranger could use to probe who our customers are; it says only that we
// could not link this sign-in, and how to get access. It does not name an
// email either: the portal never has one (the sign-in callback does not read the
// email claim), so there is nothing to show and nothing to mis-show.
// decision: docs/features/customer-storefront/13_..._impact_assessment.md,
// 23_p4_overview.md Decision 10

export function PortalNoAccessPage() {
  return (
    <PortalSignInOutcomeGate kinds={["no_access"] as const}>
      {(_outcome, scenario) => (
        <PortalSignInShell
          title="We can't give you access yet"
          subtitle="We couldn't link your sign-in to a Pollards customer."
          footer={<PortalReviewBar current={scenario} />}
        >
          <Card className="gap-3 p-5">
            <div className="flex items-start gap-3">
              <MailQuestion className="mt-0.5 size-5 shrink-0 text-muted-foreground" />
              <div className="space-y-2 text-sm">
                <p className="font-medium">To get access</p>
                <p className="text-muted-foreground">
                  Ask your Pollards contact to add you, or call us on 01752
                  663111 and tell us the email address you signed in with. It
                  can also happen if we hold a different address for you: if so,
                  sign in with that one.
                </p>
              </div>
            </div>
          </Card>
          <Button asChild className="w-full">
            <Link to={paths.portalSignIn()}>Try a different email address</Link>
          </Button>
          <p className="text-center text-xs text-muted-foreground">
            If we emailed you a link to a quote or an order, that link still
            works without signing in.
          </p>
        </PortalSignInShell>
      )}
    </PortalSignInOutcomeGate>
  );
}
